<template>
  <div class="card-detalhes-pedido-expedido-faturado">      
    <g-card class="card-consultas-produtos-cliente" :temCabecalho="false" :expansivel="false">
      <div class="header-detalhes-secundario">
        <div class="header-detalhes-secundario-titulo">
          <g-button
            class="buscar-button-header"
            largura="35px"
            icone="icone_voltar.svg"
            negritoTexto
            tamanhoIcone="10px"
            cor="#FFFFFF"
            altura="30px"
            :sombreado="false"
            @click="voltar()"
          />
          <div class="titulo-detalhes-cabecalho"> Detalhes </div>
        </div>

        <div class="header-icons">
          <g-button
            class="botoes"
            altura="35px"
            largura="35px"
            tamanhoIcone="15px"
            icone="pi pi-car"
          />
            
          <g-button
            v-tooltip="'Abrir PDF'"
            class="botoes"
            altura="35px"
            largura="35px"
            tamanhoIcone="15px"
            icone="icone_print.svg"
            @click="imprimir()"
          />
        </div>
      </div>

      <div class="conteudo-card-detalhes-pedido-cancelados-liquidados espacamento-detalhes">
        <div class="detalhes-pedido grupo">
          <div class="dados-pedido-titulo titulo-grupo-detalhes"> Detalhes do Pedido </div>

          <div class="detalhesPedidoConteudo">
            <div class="dados-pedido">
              <div class="titulo-conteudo-detalhes"> Pedido </div>
              <div class="label-conteudo"> {{ detalhesDoPedidoFluxo.CodigoExternoPedido }} </div>
            </div>

            <div class="dados-pedido-cliente">
              <div class="titulo-conteudo-detalhes"> Cliente / CNPJ </div>
              <div class="label-conteudo"> {{ detalhesDoPedidoFluxo.CodigoExternoCliente }} - {{detalhesDoPedidoFluxo.NomeFantasia}} / {{ detalhesDoPedidoFluxo.CnpjFormatado }} </div>
            </div>

            <div class="dados-pedido-unidade">
              <div class="titulo-conteudo-detalhes"> Unidade </div>
              <div class="label-conteudo"> {{detalhesDoPedidoFluxo.NomeEmpresa}} </div>
            </div>

            <div class="dados-pedido-representante">
              <div class="titulo-conteudo-detalhes"> Representante </div>
              <div class="label-conteudo"> {{detalhesDoPedidoFluxo.NomeRepresentante}} </div>
            </div>

            <div class="dados-pedido-orcamento">
              <div class="titulo-conteudo-detalhes"> Orçamento </div>
              <div class="label-conteudo"> {{detalhesDoPedidoFluxo.CodigoExternoOrcamento}} </div>
            </div>

            <div class="dados-pedido-tipo">
              <div class="titulo-conteudo-detalhes"> Tipo </div>
              <div class="label-conteudo"> {{detalhesDoPedidoFluxo.TipoPedidoTexto}} </div>
            </div>

            <div class="dados-pedido-CV">
              <div class="titulo-conteudo-detalhes"> CV </div>
              <div class="label-conteudo"> {{ detalhesDoPedidoFluxo.CurvaClienteTexto }} </div>
            </div>

            <div class="dados-pedido-digitacao">
              <div class="titulo-conteudo-detalhes"> Digitação </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.DataDigitacaoFormatada}} </div>
            </div>

            <div class="dados-pedido-status">
              <div class="titulo-conteudo-detalhes"> Status </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.StatusPedidoParcelaTexto}} </div>
            </div>

            <div class="dados-pedido-frete">
              <div class="titulo-conteudo-detalhes"> Frete / Cidade </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.IndicadorDeTipoFreteEnum}} / {{novoPedidoDetalhes.NomeCidade }}</div>
            </div>
              
            <div class="dados-pedido-produto">
              <div class="titulo-conteudo-detalhes"> Produto </div>
              <div class="label-conteudo"> {{detalhesDoPedidoFluxo.NomeProduto}} </div>
            </div>

            <div class="dados-pedido-quantidadeTotal">
              <div class="titulo-conteudo-detalhes"> Qtde total </div>
              <div class="label-conteudo"> {{ formataDecimal(novoPedidoDetalhes.NumeroQuantidadeTotalFormatado) }} </div>
            </div>

            <div class="dados-pedido-preco">
              <div class="titulo-conteudo-detalhes"> Preço </div>
              <div class="label-conteudo"> {{formataMonetario(novoPedidoDetalhes.ValorPrecoFinal) }} </div>
            </div>

            <!-- <div class="dados-pedido-comissaoRep">
              <div class="titulo-conteudo-detalhes"> Comissão Repr. </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.PorcentagemComissaoRepresentante}} </div>
            </div> -->

            <div class="dados-pedido-comissaoVenda">
              <div class="titulo-conteudo-detalhes"> Comissão Vend. </div>
              <div class="label-conteudo"> {{ `${novoPedidoDetalhes.PorcentagemComissaoVenda} %` }} </div>
            </div>

            <div class="dados-pedido-condicao">
              <div class="titulo-conteudo-detalhes"> Cond. Pagamento </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.CondicaoPagamento}} </div>
            </div>

            <div class="dados-pedido-codigo">
              <div class="titulo-conteudo-detalhes"> Codigo de Acesso </div>
              <div class="label-conteudo"> {{novoPedidoDetalhes.CodigoAccesso}} </div>
            </div>

            <div class="dados-pedido-programacao">
              <div class="titulo-conteudo-detalhes"> Programação Kanban </div>
              <div class="label-conteudo"> {{detalhesDoPedidoFluxo.ProgramacaoKanban ? 'SIM' : 'NÃO'}} </div>
            </div>

            <div class="dados-pedido-papelSeda">
              <div class="titulo-conteudo-detalhes"> Papel Seda </div>
              <div class="label-conteudo"> {{ novoPedidoDetalhes.EnviarPapelSedaDescricao }} </div>
            </div>

            <div v-if="!(caracteristicasPedido.VisualAmostra &&
              caracteristicasPedido.VisualArquivoDescricao &&
              caracteristicasPedido.VisualNumeroDoProduto &&
              caracteristicasPedido.DescricaoVisualOutros)"
            > 
              <div class="dados-pedido-visual">
                <div class="titulo-conteudo-detalhes"> Visual </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.VisualAmostra == true ? 'Amostra' : ''}} </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.VisualArquivoDescricao ? `Visual Arquivo: ${caracteristicasPedido.VisualArquivoDescricao}` : ''}} </div>
                <div class="label-conteudo"> {{caracteristicasPedido.VisualNumeroDoProduto ? `Produto: ${caracteristicasPedido.VisualNumeroDoProduto}` : ''}} </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.DescricaoVisualOutros ? `Outros: ${caracteristicasPedido.DescricaoVisualOutros}` : ''}} </div>                  
              </div>
            </div>

            <div v-if="!(caracteristicasPedido.ImpressaoAmostra &&
              caracteristicasPedido.ImpressaoProvaDeCores &&
              caracteristicasPedido.ImpressaoProvaDeCoresConfeccionar &&
              caracteristicasPedido.ImpressaoNumeroPantone &&
              caracteristicasPedido.ImpressaoNumeroDoProduto &&
              caracteristicasPedido.ImpressaoOutros)"
            >  
              <div class="dados-pedido-impressao">
                <div class="titulo-conteudo-detalhes"> Impressão </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoAmostra == true ? 'Amostra' : ''}} </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoProvaDeCores == true ? 'Prova De Cores' : ''}} </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoProvaDeCoresConfeccionar == true ? 'Prova De Cores a Confeccionar' : ''}} </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoNumeroPantone ? `Pantone Nº ${caracteristicasPedido.ImpressaoNumeroPantone}` : ''}} </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoNumeroDoProduto ? `Produto: ${caracteristicasPedido.ImpressaoNumeroDoProduto}` : ''}} </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.ImpressaoOutros ? `Outros: ${caracteristicasPedido.ImpressaoOutros}` : ''}} </div>
              </div>
            </div>

            <div class="dados-pedido-facaSistema">
              <div class="titulo-conteudo-detalhes"> Faca Sistema </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaAmostra == true ? 'Amostra' : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaRiscoDeFaca == true ? 'Risco De Faca' : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaPlanta == true ? 'Planta' : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaPrototipoDescricao ? `Protótipo: ${caracteristicasPedido.FacaSistemaPrototipoDescricao}` : ''}} </div>
              <div class="label-conteudo"> {{caracteristicasPedido.CodigoFacaSistemaProduto ? `Produto: ${caracteristicasPedido.CodigoFacaSistemaProduto}` : ''}} </div>
              <div class="label-conteudo"> {{ caracteristicasPedido.FacaSistemaOutros ? `Outros: ${caracteristicasPedido.FacaSistemaOutros}` : ''}} </div>    
            </div>

            <div v-if="!(caracteristicasPedido.FacaMedidaAmostra &&
              caracteristicasPedido.FacaMedidaRiscoDeFaca &&
              caracteristicasPedido.FacaMedidaPlanta &&
              caracteristicasPedido.FacaMedidaPrototipoDescricao &&
              caracteristicasPedido.CodigoFacaMedidaProduto &&
              caracteristicasPedido.FacaMedidaOutros)"
            >
              <div class="dados-pedido-facaMedida">
                <div class="titulo-conteudo-detalhes"> Faca Medida </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaAmostra == true ? 'Amostra' : ''}} </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaRiscoDeFaca == true ? 'Risco De Faca' : ''}} </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaPlanta == true ? 'Planta' : ''}} </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaPrototipoDescricao ? `Protótipo: ${caracteristicasPedido.FacaMedidaPrototipoDescricao}` : ''}} </div>
                <div class="label-conteudo"> {{caracteristicasPedido.CodigoFacaMedidaProduto ? `Produto: ${caracteristicasPedido.CodigoFacaMedidaProduto}` : ''}} </div>
                <div class="label-conteudo"> {{ caracteristicasPedido.FacaMedidaOutros ? `Outros: ${caracteristicasPedido.FacaMedidaOutros}` : ''}} </div>
              </div>
            </div>

            <div class="dados-pedido-critica">
              <div class="titulo-conteudo-detalhes"> Crítica do Processo </div>
              <div class="label-conteudo"> {{ detalhesDoPedidoFluxo.Critica4  ? 'SIM' : 'NÃO'}} </div>
            </div>
          </div>
        </div>

        <div class="grupo-componentes grupo">
          <div class="titulo-grupo-detalhes"> Componentes </div>

          <div class="content-componentes" v-if="this.ComponentePedidoArray?.length > 0">
            <div 
              class="box-componente" 
              v-for="(data, index) in ComponentePedidoArray"
              :key="data"
            >
              <div class="imagem-numero-nome-componente">
                <div class="imagem-grupo-componente">
                  <img src="@/assets/imgs/icone_componente_orcamento.svg" class="img-componente">
                </div>
                
                <div class="numero-nome-componente">
                  <div class="titulo-conteudo-detalhes numero-componente"> Componente {{ index + 1 }}</div>
                  <div class="nome-componente label-conteudo">{{ data.componenteTipoTexto }}</div>
                </div>
              </div> 

              <div class="grupo-componentes">
                <div class="componentes-medidas">
                  <div class="medidas titulo-conteudo-detalhes"> Medidas </div>
                  <div class="medidas label-conteudo">
                    {{ (data.numeroComprimento != 0) && (data.numeroLargura != 0)   ? this.ColunaMedidas : data.descricaoMedidasTexto }}
                  </div>
                </div>

                <div class="componentes-cor-frente">
                  <div class="corFrente titulo-conteudo-detalhes"> Cor Frente </div>
                  <div class="corFrente label-conteudo"
                  >
                    {{ data.descricaoCoresFrenteTexto }} / {{ data.nomeCorFrente }}
                  </div>
                </div>

                <div class="componentes-cor-verso">
                  <div class="corVerso titulo-conteudo-detalhes"> Cor Verso </div>
                  <div class="corVerso label-conteudo"
                  >
                    {{ data.descricaoCoresVersoTexto }} / {{ data.nomeCorVerso }}
                  </div>
                </div>

                <div class="componentes-acabFrente">
                  <div class="acabFrente titulo-conteudo-detalhes"> Acabamento Frente </div>
                  <div class="acabFrente label-conteudo">{{ data.descricaoAcabamentoFrenteTexto }}</div>
                </div>

                <div class="componentes-acabVerso">
                  <div class="acabVerso titulo-conteudo-detalhes"> Acabamento Verso </div>
                  <div class="acabVerso label-conteudo">{{ data.descricaoAcabamentoVersoTexto }}</div>
                </div>

                <div class="componentes-material">
                  <div class="material titulo-conteudo-detalhes"> Material </div>
                  <div class="material label-conteudo">{{ data.descricaoMaterialTexto }}</div>
                </div>

                <div class="componentes-onda">
                  <div class="onda titulo-conteudo-detalhes"> Onda </div>
                  <div class="onda label-conteudo">{{ data.descricaoOndaTexto }}</div>
                </div>

                <div class="componentes-capaExt">
                  <div class="capaExt titulo-conteudo-detalhes"> Capa Externa </div>
                  <div class="capaExt label-conteudo">{{ data.descricaoCapaExternaTexto }}</div>
                </div>

                <div class="componentes-gramaturaExt">
                  <div class="gramaturaExt titulo-conteudo-detalhes"> Gramatura </div>
                  <div class="gramaturaExt label-conteudo">{{ data.numeroGramaturaCapaExterna }}</div>
                </div>

                <div class="componentes-capaInt">
                  <div class="capaInt titulo-conteudo-detalhes"> Capa Interna </div>
                  <div class="capaInt label-conteudo">{{ data.descricaoCapaInternaTexto }}</div>
                </div>

                <div class="componentes-gramaturaInt">
                  <div class="gramaturaInt titulo-conteudo-detalhes"> Gramatura </div>
                  <div class="gramaturaInt label-conteudo">{{ data.numeroGramaturaCapaInterna }}</div>
                </div>

                <div class="componentes-papelOnda">
                  <div class="papelOnda titulo-conteudo-detalhes"> Papel de Onda </div>
                  <div class="papelOnda label-conteudo">{{ data.descricaoPapelOndaTexto }}</div>
                </div>

                <div class="componentes-gramaturaPO">
                  <div class="gramaturaPO titulo-conteudo-detalhes"> Gramatura </div>
                  <div class="gramaturaPO label-conteudo">{{ data.numeroGramaturaPapelOnda }}</div>
                </div>

                <div class="componentes-descricao">
                  <div class="desc-componente titulo-conteudo-detalhes"> Descrição do Sistema </div>
                  <div class="label-conteudo">{{ data.sistema }}</div>
                </div>

                <div class="componentes-embalagem-coletiva" 
                  v-if="data.embalagens.length > 0"
                >
                  <div class="embalagem titulo-conteudo-detalhes"> Embalagem Coletiva </div>
                  <div class="labels-embalagem-coletiva">
                    <div class="label-conteudo" v-for="(texto, index) in data.embalagens" :key="index"
                    >
                      {{ texto }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="label-sem-componentes label-conteudo" v-else> Não possui componentes. </div>
        </div>

        <div class="observacao-titulo titulo-grupo-detalhes"> Observações </div>
        <div class="grupo-observacao">
          <div class="dados-observacoes-observacaoVisual">
            <div class="titulo-conteudo-detalhes"> Observações do Visual, Impressão, Faca Sistema e Faca Medida </div>
            <div class="label-conteudo" v-for="(texto, index) in this.ObsArray" :key="index">
              <div class="label-conteudo"> {{ this.ObsArray ? texto : 'Sem Informações' }}  </div>
            </div>
          </div>

          <div class="dados-observacoes-observacoes">
            <div class="titulo-conteudo-detalhes"> Observações </div>
            <div class="label-conteudo"> {{novoPedidoDetalhes.ObservacaoGeral || 'Sem Informações'}} </div>
          </div>

          <div class="dados-observacoes-quantidade">
            <div class="titulo-conteudo-detalhes"> Quantidade </div>
            <div class="label-conteudo"> obs: De acordo c/ Normas Gráficas (ABIGRAF) todo pedido pode ter variação na quantidade de 10% a mais ou a menos. </div>
          </div>
        </div>
      </div>
    </g-card>
  </div>

  <g-pdf :pdfFloat="false" :NovaGuia="true" :executar="executarvisualizacao">
    <div class="render" v-if="renderiza">
      <PedidoEmAndamentoPDF 
        :tituloDetalhes="false" 
        v-on:termino="gerarPdf" 
        :pedidoSelecionado="linhaSelecionada"
        @podeGerarPDF="podeGerarPdf = $event"
      />
    </div>
  </g-pdf>
</template>

<script>
import DetalhesPedidoExpedidoFaturado from './DetalhesPedidoExpedidoFaturado.js'
export default DetalhesPedidoExpedidoFaturado
</script>

<style scoped>
.header-icons-detalhes {
  display: flex;
  justify-self: center;
  column-gap: 5px;
}

.header-titulo-voltar {
  width: 100%;
  display: flex;
  align-items: flex-end;
}

.titulo-grupo-detalhes {
  margin-bottom: 1rem;
}

.content-componentes {
  width: 100%;
  display: grid;
  gap: 1.5rem;
}
.box-componente {
  background-color: #F9F9F9;
  display: flex;
  flex-direction: column;
  row-gap: 0.2rem;
  padding: 1rem 1rem 0.5rem;
  border-radius: 0.5rem;
}
.box-componente .grupo-componentes {
  display: grid;
  grid-auto-rows: auto;
  grid-column-gap: 1rem;
}

.titulo-componentes {
    margin-bottom: 1.5rem;
}
.imagem-numero-nome-componente {
  display: flex;
  column-gap: 1rem;
}
.numero-nome-componente .titulo-conteudo-detalhes {
  margin-top: 0;
}
.numero-componente {
  color: #4f2c19 !important;
  font-size: 0.9rem !important;
}

.box-componente .titulo-conteudo-detalhes {
  color: #3f3f3f;
  margin-top: 0.1rem;
  font-size: 0.9rem;
}

.box-componente .label-conteudo {
  font-size: 0.9rem;
}

.labels-embalagem-coletiva {
  display: flex;
  flex-wrap: wrap;
  column-gap: 1.5rem;
  width: 100%;
}

@media(min-width:310px) {
.grupo-componentes {
  margin-top: 1rem;
}
.grupo-dados-produto, .grupo-observacao {
  column-gap: 6%;
}

.grupo-observacao {
  display: flex;
  flex-direction: column;
}

.detalhesPedidoConteudo {
  border-bottom: none;
  margin-top: 10px;
  display: grid;
  grid-template-columns: 50% auto;
  grid-template-rows: repeat(11, auto);
  grid-column-gap: 0.5rem;
}

.dados-pedido { grid-area: 1 / 1 / 2 / 2; }
.dados-pedido-orcamento { grid-area: 1 / 2 / 2 / 3; }
.dados-pedido-cliente { grid-area: 2 / 1 / 3 / 3; }
.dados-pedido-unidade { grid-area: 3 / 1 / 4 / 2; }
.dados-pedido-representante { grid-area: 3 / 2 / 4 / 3; }
.dados-pedido-tipo { grid-area: 4 / 1 / 5 / 2; }
.dados-pedido-CV { grid-area: 4 / 2 / 5 / 3; }
.dados-pedido-digitacao { grid-area: 5 / 1 / 6 / 2; }
.dados-pedido-status { grid-area: 5 / 2 / 6 / 3; }
.dados-pedido-produto { grid-area: 6 / 1 / 7 / 3; }
.dados-pedido-frete { grid-area: 7 / 1 / 8 / 3; }
.dados-pedido-quantidadeTotal { grid-area: 8 / 1 / 9 / 2; }
.dados-pedido-preco { grid-area: 8 / 2 / 9 / 3; }
.dados-pedido-comissaoRep { grid-area: 9 / 1 / 10 / 2; }
.dados-pedido-comissaoVenda { grid-area: 9 / 2 / 10 / 3; }
.dados-pedido-condicao { grid-area: 10 / 1 / 11 / 2; }
.dados-pedido-codigo { grid-area: 10 / 2 / 11 / 3; }
.dados-pedido-programacao { grid-area: 11 / 1 / 12 / 2; }
.dados-pedido-papelSeda { grid-area: 11 / 2 / 12 / 3; }
.dados-pedido-visual { grid-area: 12 / 1 / 13 / 2; }
.dados-pedido-impressao { grid-area: 12 / 2 / 13 / 3; }
.dados-pedido-facaSistema { grid-area: 13 / 1 / 14 / 2; }
.dados-pedido-facaMedida { grid-area: 13 / 2 / 14 / 3; }
.dados-pedido-critica { grid-area: 14 / 1 / 15 / 3; }

.grupo-dados-produto {
  display: flex;
  flex-direction: column;
}
}

@media(min-width:450px) {
.box-componente .grupo-componentes {
  grid-template-columns: repeat(2, minmax(4rem, 1fr));
}
.componentes-medidas { grid-area: 1 / 1 / 2 / 2; }
.componentes-cor-frente { grid-area: 2 / 1 / 3 / 2; }
.componentes-cor-verso { grid-area: 2 / 2 / 3 / 3; }
.componentes-acabFrente { grid-area: 3 / 1 / 4 / 2; }
.componentes-acabVerso { grid-area: 3 / 2 / 4 / 3; }
.componentes-material { grid-area: 4 / 1 / 5 / 2; }
.componentes-onda { grid-area: 4 / 2 / 5 / 3; }
.componentes-capaExt { grid-area: 5 / 1 / 6 / 2; }
.componentes-gramaturaExt { grid-area: 5 / 2 / 6 / 3; }
.componentes-capaInt { grid-area: 6 / 1 / 7 / 2; }
.componentes-gramaturaInt { grid-area: 6 / 2 / 7 / 3; }
.componentes-papelOnda { grid-area: 7 / 1 / 8 / 2; }
.componentes-gramaturaPO { grid-area: 7 / 2 / 8 / 3; }
}

@media (min-width:500px) {
.componentes-embalagem-coletiva { 
  grid-column: span 2; 
}
}

@media(min-width:600px) {
.grupo-dados-produto {
  display: grid;
  grid-template-columns: 50% auto;
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 10px;
}

.dados-produto { grid-area: 1 / 1 / 2 / 3; }
.dados-produto-versaoAtual { grid-area: 2 / 1 / 3 / 2; }
.dados-produto-dataFaturamento { grid-area: 2 / 2 / 3 / 3; }
.dados-produto-dataVenda { grid-area: 3 / 1 / 3 / 2; }
.dados-produto-porcentagemIPI { grid-area: 3 / 2 / 4 / 3; }

.content-componentes {
  grid-template-columns: repeat(2, minmax(2rem, 1fr));
}

.componentes-produto, 
.componentes-embalagem-coletiva { grid-column: span 2; } 
}

@media(min-width:801px) {
.dados-produto { grid-area: 1 / 1 / 2 / 2; } 
.dados-produto-porcentagemIPI { grid-area: 1 / 2 / 2 / 3; }
}

@media(min-width:1025px) {
.grupo-observacao {
  border-bottom: none;
  margin-top: 10px;
  column-gap: 6%;
}
.detalhesPedidoConteudo {
  grid-template-columns: repeat(5, auto);
  grid-template-rows: repeat(5, auto);
}

.dados-pedido { grid-area: 1 / 1 / 2 / 2; }
.dados-pedido-orcamento { grid-area: 1 / 2 / 2 / 3; }
.dados-pedido-cliente { grid-area: 1 / 3 / 2 / 4; }
.dados-pedido-unidade { grid-area: 1 / 4 / 2 / 5; }
.dados-pedido-representante { grid-area: 1 / 5 / 2 / 6; }
.dados-pedido-tipo { grid-area: 2 / 1 / 3 / 2; }
.dados-pedido-CV { grid-area: 2 / 2 / 3 / 3; }
.dados-pedido-digitacao { grid-area: 2 / 3 / 3 / 4; }
.dados-pedido-status { grid-area: 2 / 4 / 3 / 5; }
.dados-pedido-produto { grid-area: 2 / 5 / 3 / 6; }
.dados-pedido-frete { grid-area: 3 / 1 / 4 / 2; }
.dados-pedido-quantidadeTotal { grid-area: 3 / 2 / 4 / 3; }
.dados-pedido-preco { grid-area: 3 / 3 / 4 / 4; }
.dados-pedido-comissaoRep { grid-area: 3 / 4 / 5 / 5; }
.dados-pedido-comissaoVenda { grid-area: 3 / 5 / 4 / 6; }
.dados-pedido-condicao { grid-area: 4 / 1 / 5 / 2; }
.dados-pedido-codigo { grid-area: 4 / 2 / 5 / 3; }
.dados-pedido-programacao { grid-area: 4 / 3 / 5 / 4; }
.dados-pedido-papelSeda { grid-area: 4 / 4 / 5 / 5; }
.dados-pedido-visual { grid-area: 4 / 5 / 5 / 6; }
.dados-pedido-impressao { grid-area: 5 / 1 / 6 / 2; }
.dados-pedido-facaSistema { grid-area: 5 / 2 / 6 / 3; }
.dados-pedido-facaMedida { grid-area: 5 / 3 / 6 / 4; }
.dados-pedido-critica { grid-area: 5 / 4 / 6 / 5; }

.grupo-dados-produto {
  display: grid;
  grid-template-columns: repeat(3, auto);
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 10px;
}

.dados-produto { grid-area: 1 / 1 / 2 / 2; }
.dados-produto-versaoAtual { grid-area: 1 / 2 / 2 / 3; }
.dados-produto-dataFaturamento { grid-area: 1 / 3 / 2 / 4; }
.dados-produto-dataVenda { grid-area: 2 / 1 / 3 / 2; }
.dados-produto-porcentagemIPI { grid-area: 2 / 2 / 3 / 3; }

.content-componentes {
  column-gap: 4rem;
}
.imagem-numero-nome-componente {
  padding: 0.5rem 1rem;
}
.grupo-componentes {
  padding: 0 1rem;
}
}

@media(min-width:1285px) {
  .content-componentes {
    grid-template-columns: repeat(3, minmax(2rem, 1fr));
    column-gap: 1.5rem;
  }

  .imagem-numero-nome-componente, .grupo-componentes {
    padding: 0;
  }

  .box-componente .grupo-componentes {
    grid-template-columns: repeat(2, minmax(4rem, 1fr));
  }
  .componentes-medidas { grid-area: 1 / 1 / 2 / 2; }
  .componentes-cor-frente { grid-area: 2 / 1 / 3 / 2; }
  .componentes-cor-verso { grid-area: 2 / 2 / 3 / 3; }
  .componentes-acabFrente { grid-area: 3 / 1 / 4 / 2; }
  .componentes-acabVerso { grid-area: 3 / 2 / 4 / 3; }
  .componentes-material { grid-area: 4 / 1 / 5 / 2; }
  .componentes-onda { grid-area: 4 / 2 / 5 / 3; }
  .componentes-capaExt { grid-area: 5 / 1 / 6 / 2; }
  .componentes-gramaturaExt { grid-area: 5 / 2 / 6 / 3; }
  .componentes-capaInt { grid-area: 6 / 1 / 7 / 2; }
  .componentes-gramaturaInt { grid-area: 6 / 2 / 7 / 3; }
  .componentes-papelOnda { grid-area: 7 / 1 / 8 / 2; }
  .componentes-gramaturaPO { grid-area: 7 / 2 / 8 / 3; }
  .componentes-embalagem-coletiva { grid-column: span 2; }
}

@media(min-width:1500px) {
  .grupo-dados-produto{
    display: grid;
    grid-template-columns: repeat(5, auto);
    grid-template-rows: 1fr;
    grid-column-gap: 10px;
  }
  .dados-produto { grid-area: 1 / 1 / 2 / 2; }
  .dados-produto-versaoAtual { grid-area: 1 / 2 / 2 / 3; }
  .dados-produto-dataFaturamento { grid-area: 1 / 3 / 2 / 4; }
  .dados-produto-dataVenda { grid-area: 1 / 4 / 2 / 5; }
  .dados-produto-porcentagemIPI { grid-area: 1 / 5 / 2 / 6; }

  .content-componentes {
    grid-template-columns: repeat(4, minmax(2rem, 1fr));
  }
}
</style>